import {useEffect, useState} from 'react';
import ReservationsOverviewTable from '../../../../common/RoomReservations/ReservationsOverviewPage/ReservationsOverviewTable.jsx';
import ReservationsOverviewForm from '../../../../common/RoomReservations/ReservationsOverviewPage/ReservationsOverviewForm.jsx';
import {routes} from '../../../../../utils/helpers/ApiClient.jsx';
import {Spinner} from '../../../../common/index.jsx';
import {AppBarCMS} from '../../../../basic/index.jsx';
import {useTranslation} from 'react-i18next';
import {useGetReservationsForOverviewQuery} from '../../../../../redux/services/reservations.jsx';
import {useGetRoomsForReservationQuery} from '../../../../../redux/services/rooms.jsx';
import {CollapseBlock} from "../../../../common/index.jsx";
import useReservationsOverviewMonth from '../../../../../hooks/useReservationsOverviewMonth.jsx';

const ReservationsOverviewPage = () => {
  const {t} = useTranslation();

  const {data: rooms, isLoading: isLoadingRooms} = useGetRoomsForReservationQuery();

  useEffect(() => {
    document.title = t('Prehľad rezervácií miestností') + ' - FRI CMS';
  }, []);

  const [selectedDate, setSelectedDate] = useReservationsOverviewMonth();
  const [showRooms, setShowRooms] = useState([]);

  const {data: reservations, isLoading: isLoadingReservations} = useGetReservationsForOverviewQuery(
    {month: selectedDate.format('YYYY-MM')},
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    }
  );


  if (!rooms || isLoadingRooms) {
    return <Spinner/>;
  }
  return (
    <>
      <AppBarCMS
        title={t('Prehľad rezervácií')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{margin: '10px'}}>
        <CollapseBlock
          collapsible={true}
          title={t('Filter zobrazenia rezervácií')}
          defaultCollapsed={true}
        >
          <div className="month-pick-form">
            <ReservationsOverviewForm
              selectedDate={selectedDate}
              onFinish={(m) => {
                setSelectedDate(m);
              }}
              setShowRooms={setShowRooms}
              hasDepartmentRooms={rooms.some((room) => room.department_room === 'Yes')}
            />
          </div>
        </CollapseBlock>

        <CollapseBlock title={t('Tabuľka rezervácií')} collapsible={false}>
            <ReservationsOverviewTable
              reservations={reservations}
              rooms={rooms}
              isLoadingReservations={isLoadingReservations}
              selectedDate={selectedDate}
              showOnlyRooms={showRooms}
              isCms={true}
            />
          </CollapseBlock>

          <CollapseBlock
            collapsible={true}
            title={t('Legenda')}
          >
            <div style={{paddingLeft: '15px', backgroundColor: '#ffb81c', display: 'inline'}}></div>
            &nbsp;{t('Vaša schválená rezervácia')}
            &nbsp;&nbsp;
            <div style={{paddingLeft: '15px', backgroundColor: '#f5e0b5', display: 'inline'}}></div>
            &nbsp;{t('Vaša rezervácia, čakajúca na schválenie')}
            &nbsp;&nbsp;
            <div style={{paddingLeft: '15px', backgroundColor: '#6B839F', display: 'inline'}}></div>
            &nbsp;{t('Cudzia schválená rezervácia')}
            &nbsp;&nbsp;
            <div style={{paddingLeft: '15px', backgroundColor: '#C2D6F1', display: 'inline'}}></div>
            &nbsp;{t('Cudzia rezervácia, čakajúca na schválenie')}
            &nbsp;&nbsp;
            <div style={{paddingLeft: '15px', backgroundColor: 'darkgrey', display: 'inline'}}></div>
            &nbsp;{t('rezervácia v minulosti')}
            {rooms.some((room) => room.department_room === 'Yes') && (
              <p>
                {t('Tmavšie pozadie v záhlaví tabuľky = katedrová miestnosť (iným katedrám sa nezobrazuje, povolené sú len rezervácie z katedry)')}
              </p>
            )}
          </CollapseBlock>
      </div>
    </>
  );
};

export default ReservationsOverviewPage;
